if($('header#header').length){
    $('.responsive-tools').append($('.header-top .navigation-buttons a.cart-count').clone())
    $('.top-navigation-tools .dropdown').clone().appendTo('.responsive-tools')
    $('.header-top .navigation-buttons').append($('.top-navigation-bar .responsive-tools'))
    $('#customerLogin input[name="email"]').attr('placeholder', '').before('<label for="email">'+uzivatelskeJmeno+'<span>*</span></label>')
	$('#customerLogin input[name="password"]').attr('placeholder', '').before('<label for="password">'+heslo+'<span>*</span></label>')  
    $('<span class="close"></span>').appendTo('.popup-widget-inner');
    $(document).on("click", ".login-widget .popup-widget-inner .close", function(){
        $('body').removeClass('user-action-visible login-window-visible')
    });
    $('.navigation-in').append('<ul class="navigationActions"><li>'+$('.languagesMenu').html()+'</li></ul>')
    
   
    const storedVat = localStorage.getItem('vatPreference') || 'yes';
    updatePriceDisplay(storedVat);
}

 $('html').on('click', '.priceWith ul li', function() {
    const vat = $(this).data('vat');
    updatePriceDisplay(vat);
    $('.priceWith ul').removeClass('open')
});

$('html').on('click', '#topNavigationDropdown', function() {
    $('.priceWith ul').removeClass('open')
});

function updatePriceDisplay(vat) {
        localStorage.setItem('vatPreference', vat);
        $('.product').removeClass('haveVat noVat');
        $('.type-detail .p-final-price-wrapper').removeClass('haveVat noVat');
        $('.price-wrapper').removeClass('haveVat noVat');
        if (vat === 'yes') {
            $('.product').addClass('haveVat');
            $('.type-detail .p-final-price-wrapper').addClass('haveVat');
            $('.price-wrapper').addClass('haveVat');
        } else {
            $('.product').addClass('noVat');
            $('.type-detail .p-final-price-wrapper').addClass('noVat');
            $('.price-wrapper').addClass('noVat');
        }
        const label = vat === 'yes' ? '<u>'+sDPH+'</u>' : '<u>'+bezDPH+'</u>';
        $('.priceLabel u').html(label);
}